import { render, staticRenderFns } from "./infoStages.vue?vue&type=template&id=65066f72&scoped=true"
import script from "./infoStages.vue?vue&type=script&lang=js"
export * from "./infoStages.vue?vue&type=script&lang=js"
import style0 from "./infoStages.vue?vue&type=style&index=0&id=65066f72&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65066f72",
  null
  
)

export default component.exports